import React, {createContext} from 'react';
import NotificationService from "./services/notificationService/notificationService";
import EmailService from "./services/emailService/emailService";

export const AppContext = createContext({
    notificationService: () => {},
    emailService: () => {}
});


export default function Provider ({children}){
    const contextValue = {
        notificationService: NotificationService(),
        emailService: EmailService()
    };

    return (
        <AppContext.Provider value={contextValue}>
            {children}
        </AppContext.Provider>
    );
};
//export const Consumer = AppContext.Consumer;
